import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button, Header} from 'semantic-ui-react';

import {notificationsShow} from '../../../actions/notifications';

class PortfolioNotifications extends Component {

    notificationsShow = () => this
        .props
        .notificationsShow(
            {header: 'Notification Title', content: 'Notification content. Lorem ipsum dolor sit amet.'}
        );

    render() {
        return <div className="PortfolioNotifications">
            <Header as='h3' dividing={true}>Notifications</Header>
            <Button onClick={this.notificationsShow}>
                Show Notification
            </Button>
        </div>;
    }
}

export default connect(null, {notificationsShow})(PortfolioNotifications);



// WEBPACK FOOTER //
// ./src/apps/portfolio/components/Notifications.js